import Vue from 'vue'
import Router from 'vue-router'
// 首页
import Index from '@/components/Index'
// 首页
// import IndexAsso from '@/components/IndexAsso'
// 活动列表
import ActionMsgList from '@/components/aboutAction/ActionMsgList'
// 新闻列表
import NewList from '@/components/aboutNews/NewsList'
// 新闻详情
import NewsDetails from '@/components/aboutNews/NewsDetails'
// 活动详情
import ActionMsgDetails from '@/components/aboutAction/ActionMsgDetails'
// 协会简介
import AboutAsso from '@/components/aboutAsso/AboutAsso'
// Mna列表
import MnaList from '@/components/Mna/MnasList'
// Mna详情
import MnaDetails from '@/components/Mna/MnaDetails'

// Mna列表
import FocussList from '@/components/Focus/FocussList'
// Mna详情
import FocusDetails from '@/components/Focus/FocusDetails'
// Mna列表
import AntiDopingList from '@/components/AntiDoping/AntiDopingsList'
// Mna详情
import AntiDopingDetails from '@/components/AntiDoping/AntiDopingDetails'

// 名师详情
import TopTeacherDetails from '@/components/topTeacher/TeacherDetails'
// banner
// import Banner from '@/components/common/Banner/Banner'
// 导航tab
// import Tabs from '@/components/common/Tabs/Tabs'
// 公告、活动消息
//  import Notice from '@/components/common/Notice/Notice'
// 会员单位
// import MemberUnit from '@/components/common/MemberUnit/MemberUnit'
// 个人会员
// import SignMember from '@/components/common/SignMember/SignMember'
// 精彩图集
// import Photos from '@/components/common/Photos/Photos'
// 登录
import Login from '@/components/pages/Login.vue'
// 注册
import Register from '@/components/register/Index.vue'
// 重新完善驳回的信息
import ComplementInfo from '@/components/register/ComplementInfo.vue'
// 个人证书查询
import PersonalCertificate from '@/components/pages/PersonalCertificate.vue'
// 个人证书查询结果
import QueryResult from '@/components/pages/QueryResult.vue'
// 个人信息
import PersonInfo from '@/components/common/UserCenter/PersonInfo .vue'
// 个人中心查询结果
import ReferCertificate from '@/components/common/UserCenter/ReferCertificate.vue'
// 打印证书
import PrintCert from '@/components/common/UserCenter/PrintCert.vue'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Index,
      meta: {
        title: '首页'
      }
    },
    {
      path: '/AboutAsso',
      name: 'AboutAsso',
      component: AboutAsso,
      meta: {
        title: '协会简介'
      }
    },
    {
      path: '/NewList/:type/',
      name: 'NewList',
      component: NewList,
      meta: {
        title: '新闻'
      }
    },
    {
      path: '/NewsDetails/:newsId/:type/',
      name: 'NewsDetails',
      component: NewsDetails,
      meta: {
        title: '新闻详情'
      }
    },
    {
      path: '/ActionMsgList/:type/',
      name: 'ActionMsgList',
      component: ActionMsgList,
      meta: {
        title: '活动信息'
      }
    },
    {
      path: '/ActionMsgDetails/:id/:type/:info/',
      name: 'ActionMsgDetails',
      component: ActionMsgDetails,
      meta: {
        title: '活动详情'
      }
    },
    {
      path: '/MnaList/',
      name: 'MnaList',
      component: MnaList,
      meta: {
        title: 'MNA'
      }
    },
    {
      path: '/MnaDetails/',
      name: 'MnaDetails',
      component: MnaDetails,
      meta: {
        title: 'MNA详情'
      }
    },
    {
      path: '/FocussList/',
      name: 'FocussList',
      component: FocussList,
      meta: {
        title: '焦点列表'
      }
    },
    {
      path: '/FocusDetails/',
      name: 'FocusDetails',
      component: FocusDetails,
      meta: {
        title: '焦点详情'
      }
    },
    {
      path: '/AntiDopingList/',
      name: 'AntiDopingList',
      component: AntiDopingList,
      meta: {
        title: '医疗与反兴奋剂'
      }
    },
    {
      path: '/AntiDopingDetails/',
      name: 'AntiDopingDetails',
      component: AntiDopingDetails,
      meta: {
        title: '医疗与反兴奋剂详情'
      }
    },

    {
      path: '/TopTeacherDetails/',
      name: 'TopTeacherDetails',
      component: TopTeacherDetails,
      meta: {
        title: '名师详情'
      }
    },
    {
      path: '/Login',
      name: 'Login',
      component: Login,
      meta: {
        title: '登录'
      }
    },
    {
      path: '/Register',
      name: 'Register',
      component: Register,
      meta: {
        title: '注册'
      }
    },
    {
      path: '/ComplementInfo',
      name: 'ComplementInfo',
      component: ComplementInfo,
      meta: {
        title: '完善信息'
      }
    },

    {
      path: '/PersonalCertificate',
      name: 'PersonalCertificate',
      component: PersonalCertificate,
      meta: {
        title: '个人证书查询'
      }
    },
    {
      path: '/QueryResult',
      name: 'QueryResult',
      component: QueryResult,
      meta: {
        title: '个人证书查询结果'
      }
    },
    {
      path: '/PersonInfo',
      name: 'PersonInfo',
      component: PersonInfo,
      meta: {
        title: '个人信息'
      }
    },
    {
      path: '/ReferCertificate',
      name: 'ReferCertificate',
      component: ReferCertificate,
      meta: {
        title: '证书查询结果'
      }
    },
    {
      path: '/PrintCert',
      name: 'PrintCert',
      component: PrintCert,
      meta: {
        title: '打印证书  '
      }
    }

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js